import { ComponentRef } from '@angular/core';
import { AppInjectorService } from '@app/core/services/app-injector.service';
import { BulkActionHandler } from '@app/shared/components/bulk-actions/models/bulk-action-handler';
import { Constructor } from '@app/shared/models/constructor';
import { DynamicComponentFactory } from '@app/shared/services/dynamic-component-factory.service';

/**
 * Function that creates a component instance and attaches it to a node.
 * @param node DOM node to which the created instance will be attached.
 */
export type BulkActionHandlerFactory<T, Input = void> = (
  node: Node
) => ComponentRef<BulkActionHandler<T, Input>>;

/**
 * Create a factory function for the given component that can be used to create a component instance
 * and attach it to a node.
 * @param component Component to create.
 * @param input Input parameters that are passed to the created component instance.
 */
export function bulkActionHandler<T, Input = void>(
  component: Constructor<BulkActionHandler<T, Input>>,
  input?: Input
): BulkActionHandlerFactory<T> {
  return (node: Node): ComponentRef<BulkActionHandler<T, Input>> => {
    const dynamicComponentFactory = AppInjectorService.injector.get(DynamicComponentFactory);
    const componentRef = dynamicComponentFactory.create(component, node);

    if (input != null) {
      Object.entries(input).forEach(([key, value]) => {
        componentRef.instance[key] = value;
      });
    }

    return componentRef;
  };
}
